module.exports = __webpack_public_path__ + "static/media/unverified-orders-menu-icon-new.29bd6ac7.svg";